import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
var ConfirmCancelDialog = function (_a) {
    var _b = _a.open, open = _b === void 0 ? true : _b, title = _a.title, children = _a.children, onConfirm = _a.onConfirm, onCancel = _a.onCancel, onClose = _a.onClose, confirmDisabled = _a.confirmDisabled;
    return (React.createElement(Dialog, { className: "confirmCancelDialog", open: open, container: document.getElementById('appContainer') },
        React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null, children)),
        React.createElement(DialogActions, null,
            onCancel && React.createElement(Button, { onClick: onCancel, color: 'secondary' }, "Cancel"),
            React.createElement(Button, { disabled: confirmDisabled, onClick: onConfirm, color: 'primary' }, onCancel ? 'Confirm' : 'Ok'))));
};
export default ConfirmCancelDialog;
//# sourceMappingURL=ConfirmCancelDialog.js.map